module.exports = __webpack_public_path__ + "img/closed-white.dbdd8123.svg";